import { FilterType, Filter, FilterKey } from 'types';
import { IGetFilterGroupsProps } from '../../types';

const DaysIdleOptions = [
  {
    key: FilterKey.MINIMUM_DAYS_IDLE,
    label: 'Minimum days idle',
  },
  {
    key: FilterKey.MAXIMUM_DAYS_IDLE,
    label: 'Maximum days idle',
  },
];

const key = FilterKey.IDLE_DAYS;
export const getDaysIdleFilter = ({ activeFilters }: IGetFilterGroupsProps): Filter => {
  const options = DaysIdleOptions.map(({ key, label }) => {
    if (activeFilters[key]) {
      return {
        label,
        key,
        value: parseInt(activeFilters[key][0], 10),
      };
    }
    return {
      label,
      key,
    };
  });
  return {
    name: 'Days idle',
    key,
    type: FilterType.NUMBER_RANGE,
    showSearch: false,
    options: {
      NUMBER_RANGE: options,
    },
    activeFilterLabel: () => {
      const from = options[0].value;
      const to = options[1].value;
      if (Number.isInteger(from) && from === to) {
        return `${from} days`;
      } else if (Number.isInteger(from) && Number.isInteger(to)) {
        return `${from}-${to} days`;
      } else if (Number.isInteger(from)) {
        return `${from} days or more`;
      } else if (Number.isInteger(to)) {
        return `${to} days or fewer`;
      }
      return '';
    },
  };
};
